import type { DashboardMetric } from "../type";
import { SegmentsGroupMonthlyVisitsGraphWidget } from "./SegmentsGroupMonthlyVisitsGraphWidget";

export class SegmentsBounceRateGroupGraphWidget extends SegmentsGroupMonthlyVisitsGraphWidget {
    protected metric: DashboardMetric;
    protected dataSource;

    constructor() {
        super();
        this.dataSource = "BounceRate";
        this.metric = "SegmentsBounceRateGroup";
    }

    static getWidgetDashboardType() {
        return "Graph";
    }

    static getWidgetResourceType() {
        return "Graph";
    }

    static getWidgetMetadataType() {
        return "SegmentsBounceRateGroupGraph";
    }

    public getGraphData(transformedData) {
        return super.getGraphData(transformedData, this.metric);
    }
}

SegmentsBounceRateGroupGraphWidget.register();
